export const FETCH_PROJECTS_INITIATE = 'FETCH_PROJECTS_INITIATE';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';
